import firebase from "firebase/app";
import "firebase/auth";
export const auth = firebase.initializeApp( {
    apiKey: "AIzaSyDurFpOYS1by-ya0Y70Xx-TAfhOaMEIhks",
    authDomain: "chitchat-85224.firebaseapp.com",
    projectId: "chitchat-85224",
    storageBucket: "chitchat-85224.appspot.com",
    messagingSenderId: "213853632276",
    appId: "1:213853632276:web:ec3058f287f202fe16f401"
  }).auth();